"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightToolbar = exports.CenterToolbar = exports.LeftToolbar = exports.IconWrapper = exports.Wrapper = void 0;
const styled_1 = __importDefault(require("../../styles/styled"));
const flex_1 = require("../layout/flex");
exports.Wrapper = styled_1.default.div({
    display: 'flex',
    height: '40px',
    width: '100%',
    background: '#FFFFF',
});
exports.IconWrapper = (0, styled_1.default)(flex_1.Flex)({
    height: '100%',
    width: '40px',
    transition: 'background .1s linear',
    fontSize: '1em',
    cursor: 'pointer',
}, ({ active, theme }) => {
    if (!active) {
        return {
            ':hover': {
                background: theme.colors.grey10,
            },
        };
    }
    return {
        background: theme.colors.azure,
    };
});
exports.LeftToolbar = (0, styled_1.default)(flex_1.Flex)({
    justifyContent: 'flex-start',
    width: '33.333%',
});
exports.CenterToolbar = (0, styled_1.default)(flex_1.Flex)({
    width: '33.333%',
});
exports.RightToolbar = (0, styled_1.default)(flex_1.Flex)({
    justifyContent: 'flex-end',
    width: '33.333%',
});
//# sourceMappingURL=top_toolbar.styles.js.map